/**
 * Terms:
 * bhbgc - block-header background-color
 * bha - block header adventure
 * fwb - full width bg
 */

import React from "react";
import { ProductTypeByValue } from "../../../../../part-panel/lib/product-types";
import { toElementProps } from "../../Element";

export function BlockECommerceStyles(params = {}) {
    const { palette, MobileBreakpoint } = params;

    return {
        "& .block-ecommerce": {
            padding: "40px",
            margin: "0 auto",
            width: "100%",
            color: palette.primary.initialText,
            maxWidth: "1200px",
        },
    };
}

export default function BlockECommerce(props) {
    const CNBlockECommerce = ["block-ecommerce"];

    const elProps = toElementProps(props, { className: CNBlockECommerce });
    return (
        <div {...elProps}>
            <div className="block-ecommerce-bgwrapper"></div>
            <div className="block-ecommerce-content-wrapper">{props.children}</div>
        </div>
    );
}
